import { Button, Card, Form, Select, Space, Table, Input, ConfigProvider, Popover, Pagination, message, Popconfirm, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile';
import { DeleteOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone, SearchOutlined, QuestionCircleOutlined, EyeOutlined } from "@ant-design/icons";
import axios from 'axios';
import './ManageUser.css'
import { Config } from '../Common/Config';
const { Option } = Select;
const { Title } = Typography;

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

const getInitials = (name = '', surname = '') => {
  const a = (name || '').trim()[0] || '';
  const b = (surname || '').trim()[0] || '';
  return (a + b).toUpperCase() || 'U';
};

const ManageUser = () => {
  const [form] = Form.useForm();
  const [userDataSet, setuserDataSet] = useState({})
  const [AllUserData, setAllUserData] = useState([])
  const [AllUserDataAdmin, setAllUserDataAdmin] = useState([])
  const [loader, setloader] = useState(false)
  const [CurrentPage, setCurrentPage] = useState(1)
  const [isUserCreateEnable, setisUserCreateEnable] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const [showAddButton, setshowAddButton] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [mode, setMode] = useState('edit')
  const isViewMode = mode === 'view'
  const hasFetched = useRef(false)

  // ── Search & Role Filter ──────────────────────────────────────────────────
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedRole, setSelectedRole] = useState(undefined);
  const [rolesOptions, setRolesOptions] = useState([]);
  const searchTimerRef = useRef(null);

  useEffect(() => {
    if (!hasFetched.current) {
      getAllUserData(CurrentPage)
      getAllRoles()
      hasFetched.current = true;
    }
  }, [CurrentPage])

  const getAllUserData = async (page = CurrentPage, search = searchKeyword, role = selectedRole) => {
    setloader(true)
    let adminUser = []
    try {
      const params = {};
      if (search && search.trim()) params.search = search.trim();
      if (role !== undefined && role !== null && role !== '') params.role = role;

      const response = await axios.get(`${Config.url}users/${page}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        params,
      });

      if (response && response.data && response.data.data) {
        const data = response.data.data;
        setAllUserData(data);

        // Support both old array shape and new paginated shape (users.data)
        const userList = Array.isArray(data.users)
          ? data.users
          : (data.users?.data || []);

        userList.forEach(a => {
          if (a.role && a.role.toLowerCase() === 'admin') {
            adminUser.push(a)
          }
        });
        setAllUserDataAdmin(adminUser)
      }
      setloader(false)
      hasFetched.current = false;
    } catch (error) {
      setloader(false)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
    }
  }

  const getAllRoles = async () => {
    try {
      const response = await axios.get(`${Config.url}roles`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = response?.data?.data;
      if (data && Array.isArray(data)) {
        const roles = data.map(r => ({
          label: r.name || r.role_name || String(r),
          value: r.id || r.role_id || r.name || String(r),
        }));
        setRolesOptions(roles);
      }
    } catch (error) {
      console.error('getAllRoles:', error.response?.data || error.message);
    }
  }

  // Derive user list — handles both old array and new paginated shape
  const userList = Array.isArray(AllUserData?.users)
    ? AllUserData.users
    : (AllUserData?.users?.data || []);

  const onFinish = async (values, update = false) => {
    setIsSubmitting(true)
    if (!update) {
      try {
        await axios.post(`${Config.url}register-user`, {
          "name": values?.name,
          "email": values?.email,
          "surname": values?.surname,
          'role': values?.role,
          'password': values?.password,
          confirmPassword: values.confirmPassword
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        messageApi.success({ type: 'succes', content: 'User Created successfully' });
        setuserDataSet({})
        form.setFieldsValue({ "name": '', "email": '', "surname": '', 'role': '', 'password': '', confirmPassword: '' })
        setloader(false)
        setIsSubmitting(false)
        setisUserCreateEnable(false)
        setshowAddButton(true)
        setMode('edit')
        getAllUserData(CurrentPage)
      } catch (error) {
        console.log('create user:', error.response?.data || error.message);
        messageApi.error({ type: 'error', content: error.response?.data?.message || error.message || "Something went wrong" });
        setloader(false)
        setIsSubmitting(false)
      }
    } else {
      if (!Object.keys(userDataSet).length && !userDataSet.user_id) { setloader(false); return }
      let url = `${Config.url}update-user/${userDataSet.user_id}`
      try {
        let payload = { "name": values?.name, "email": values?.email, "surname": values?.surname, 'role': values?.role }
        if (values?.password && values?.password != '') {
          payload = { ...payload, 'password': values?.password, password_confirmation: values.confirmPassword }
        }
        await axios.post(url, payload, {
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        setuserDataSet({})
        form.setFieldsValue({ "name": '', "email": '', "surname": '', 'role': '', 'password': '', confirmPassword: '' })
        setloader(false)
        setIsSubmitting(false)
        messageApi.success({ type: 'succes', content: 'User Updated successfully' });
        setisUserCreateEnable(false)
        setshowAddButton(true)
        setMode('edit')
        getAllUserData(CurrentPage)
      } catch (error) {
        console.error('update user:', error.response?.data || error.message);
        messageApi.error({ type: 'error', content: error.response?.data?.message || error.message || "Something went wrong" });
        setloader(false)
        setIsSubmitting(false)
      }
    }
  };

  const columns = [
    { title: 'First Name', dataIndex: 'name', key: 'name' },
    { title: 'Last Name', dataIndex: 'surname', key: 'surname' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Role', key: 'role', dataIndex: 'role' },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div style={{ textAlign: 'right', marginRight: 2 }} onClick={(e) => e.stopPropagation()}>
          <Popover placement="left" trigger="click" content={() => popoverContent(record)}>
            <button onClick={(e) => e.stopPropagation()} style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 18, letterSpacing: 2, color: '#008385', padding: '0 6px', lineHeight: 1 }}>···</button>
          </Popover>
        </div>
      ),
    },
  ];

  const popoverContent = (record) => (
    <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
      <div className="rule-action-item" style={{ color: '#008385' }} onClick={(e) => {
        e.stopPropagation(); setloader(true); setshowAddButton(false); setisUserCreateEnable(true); setMode('view');
        setuserDataSet(record); form.setFieldsValue(record); setloader(false);
        document.querySelector('.userCreate-form')?.scrollIntoView({ behavior: 'smooth' });
      }}>
        <EyeOutlined style={{ fontSize: 15 }} /> View
      </div>
      <div className="rule-action-item" style={{ color: '#008385' }} onClick={(e) => {
        e.stopPropagation(); setloader(true); setshowAddButton(false); setisUserCreateEnable(true); setMode('edit');
        setuserDataSet(record); form.setFieldsValue(record); setloader(false);
        document.querySelector('.userCreate-form')?.scrollIntoView({ behavior: 'smooth' });
      }}>
        <EditOutlined style={{ fontSize: 15 }} /> Edit
      </div>
      <div className="rule-action-divider" />
      <Popconfirm
        title="Delete user" description="Are you sure you want to delete this user?"
        onConfirm={() => deleteUser(record)} onCancel={(e) => e?.stopPropagation?.()}
        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        okButtonProps={{ className: 'confirmation-popup-ok-button' }}
        cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
        okText="Yes, Delete" cancelText="Cancel"
      >
        <div className="rule-action-item rule-action-item--delete">
          <DeleteOutlined style={{ fontSize: 15 }} /> Delete
        </div>
      </Popconfirm>
    </div>
  );

  const deleteUser = async (record) => {
    let url = `${Config.url}deactive-user/${record.user_id}`
    try {
      await axios.post(url, {}, { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      messageApi.success({ type: 'succes', content: 'User deleted successfully' });
      getAllUserData(CurrentPage)
    } catch (error) {
      console.error('update user:', error.response?.data || error.message);
      throw error;
    }
  }

  const createUser = () => { setMode('edit'); setisUserCreateEnable(true) }

  const handleClearform = () => {
    setMode('edit'); setshowAddButton(true);
    form.setFieldsValue({ "name": '', "email": '', "surname": '', 'role': '', 'password': '', confirmPassword: '' });
    setisUserCreateEnable(false)
  }

  return (
    <App>
      {contextHolder}
      <div style={{ display: 'grid', justifyContent: 'center' }}>

        {/* ── Header: title + search + role filter ───────────────────────── */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>

          {/* Titles */}
          {AllUserData && AllUserDataAdmin && (
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 16 }}>
              <Title level={5} style={{ margin: 0, color: '#008385', fontSize: 20 }}>
                All users <span style={{ color: 'black', fontWeight: '400' }}>({AllUserData?.total_users ?? ''})</span>
              </Title>
              <Title level={5} style={{ margin: 0, color: '#008385', fontSize: 20 }}>
                Admin <span style={{ color: 'black', fontWeight: '400' }}>({AllUserDataAdmin?.length || 0})</span>
              </Title>
            </div>
          )}

          {/* Search + Role filter (mirrors ProductCategory style) */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>

            {/* Search input */}
            <div
              style={{ display: 'flex', alignItems: 'center', border: '1px solid #d9d9d9', borderRadius: 6, overflow: 'hidden', height: 40, background: '#fff', transition: 'border-color 0.2s' }}
              onFocusCapture={(e) => e.currentTarget.style.borderColor = '#008385'}
              onBlurCapture={(e) => e.currentTarget.style.borderColor = '#d9d9d9'}
            >
              <input
                type="text"
                placeholder="Search users..."
                value={searchKeyword}
                onChange={(e) => {
                  const val = e.target.value;
                  setSearchKeyword(val);
                  if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
                  searchTimerRef.current = setTimeout(() => {
                    setCurrentPage(1);
                    getAllUserData(1, val, selectedRole);
                  }, 500);
                }}
                style={{ border: 'none', outline: 'none', padding: '0 12px', fontSize: 14, color: '#333', width: 210, height: '100%', background: 'transparent' }}
              />
              <button
                onClick={() => { if (searchTimerRef.current) clearTimeout(searchTimerRef.current); setCurrentPage(1); getAllUserData(1, searchKeyword, selectedRole); }}
                style={{ background: 'none', border: 'none', borderLeft: '1px solid #d9d9d9', cursor: 'pointer', padding: '0 12px', height: '100%', display: 'flex', alignItems: 'center', color: '#008385', fontSize: 16 }}
              >
                <SearchOutlined />
              </button>
            </div>

            {/* Role filter dropdown */}
            <Select
              placeholder="All Roles"
              style={{ width: 160, height: 40 }}
              allowClear
              value={selectedRole}
              onChange={(value) => {
                const role = value ?? undefined;
                setSelectedRole(role);
                setCurrentPage(1);
                getAllUserData(1, searchKeyword, role);
              }}
            >
              {rolesOptions.length > 0
                ? rolesOptions.map((r) => <Option key={r.value} value={r.value}>{r.label}</Option>)
                : (
                  // Static fallback matching form roles
                  <>
                    <Option value="admin">Admin</Option>
                    <Option value="Corporate-Admin">Corporate-Admin</Option>
                    <Option value="CSR">CSR</Option>
                    <Option value="CSR-R">CSR-R</Option>
                  </>
                )
              }
            </Select>
          </div>
        </div>

        {/* ── Table card ─────────────────────────────────────────────────── */}
        <Card style={{ width: 937, margin: 0, padding: 0, borderRadius: 40, boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)' }}>
          <ConfigProvider theme={{ components: { Table: { headerBg: '#008385', headerColor: '#ffffff' }, Spin: { colorPrimary: '#008385' } } }}>
            {AllUserData && (
              <Table
                className='user-table'
                loading={loader}
                columns={columns}
                dataSource={userList}
                pagination={{
                  pageSize: 20,
                  total: AllUserData?.total_users || 0,
                  current: CurrentPage,
                  onChange: (page) => { setCurrentPage(page); getAllUserData(page, searchKeyword, selectedRole); },
                  itemRender: (current, type, originalElement) => {
                    if (type === 'prev') return <a>Previous</a>;
                    if (type === 'next') return <a>Next</a>;
                    return originalElement;
                  }
                }}
                rowKey="user_id"
                onRow={(record) => ({
                  onClick: () => {
                    setloader(true); setshowAddButton(false); setisUserCreateEnable(true); setMode('view');
                    setuserDataSet(record); form.setFieldsValue(record); setloader(false);
                    document.querySelector('.userCreate-form')?.scrollIntoView({ behavior: 'smooth' });
                  },
                })}
              />
            )}
          </ConfigProvider>
        </Card>
      </div>

      {/* ── Add / Edit / View form ──────────────────────────────────────── */}
      <div className="userCreate-form" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginTop: 20, justifyContent: 'center' }}>
        {showAddButton && (
          <Button type="default" className='add-generic-btn' style={{ marginTop: 20, marginLeft: '-6%', borderColor: '#008385' }} onClick={createUser}>
            Add a user
          </Button>
        )}

        {loader == false && isUserCreateEnable && (
          <Card
            className={isViewMode ? 'clinician-view-mode-card' : ''}
            style={{ width: 705, margin: '0', marginTop: 20, borderRadius: 8, overflow: 'hidden' }}
            title={
              isViewMode ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'linear-gradient(135deg, #008385, #00a3a5)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 15, flexShrink: 0, boxShadow: '0 2px 6px rgba(0,131,133,0.30)' }}>
                    {getInitials(userDataSet?.name, userDataSet?.surname)}
                  </div>
                  <span style={{ fontWeight: 700, fontSize: 16, color: '#007a7c' }}>
                    {[userDataSet?.name, userDataSet?.surname].filter(Boolean).join(' ') || 'User'}
                  </span>
                </div>
              ) : (
                <span style={{ fontWeight: 600, fontSize: 15, color: '#1f1f1f' }}>User details</span>
              )
            }
            extra={null}
          >
            {userDataSet && loader == false && (
              <Form form={form} autoComplete="off" layout="vertical" initialValues={userDataSet || null} onFinish={(values) => onFinish(values, userDataSet && Object.keys(userDataSet).length ? true : false)}>
                {isViewMode ? (
                  <div style={{ padding: '0 4px' }}>
                    <div className="clinician-view-detail-row"><label>First Name</label><span className="clinician-view-field-value">{userDataSet?.name || '-'}</span></div>
                    <div className="clinician-view-detail-row"><label>Last Name</label><span className="clinician-view-field-value">{userDataSet?.surname || '-'}</span></div>
                    <div className="clinician-view-detail-row"><label>Email</label><span className="clinician-view-field-value">{userDataSet?.email || '-'}</span></div>
                    <div className="clinician-view-detail-row"><label>Role</label><span className="clinician-view-field-value">{userDataSet?.role || '-'}</span></div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 20, paddingBottom: 4 }}>
                      <Button onClick={handleClearform} style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}>Cancel</Button>
                      <Button className="edit-btn-green" icon={<EditOutlined />} onClick={() => setMode('edit')} style={{ minWidth: 100 }}>Edit</Button>
                    </div>
                  </div>
                ) : (
                  <>
                    <Space.Compact style={{ width: '100%' }}>
                      <Form.Item name="name" style={{ flex: 1, marginRight: 10 }} rules={[{ required: true, message: 'Please enter your enter first name' }]}>
                        <Input placeholder="First name" />
                      </Form.Item>
                      <Form.Item name="surname" style={{ flex: 1 }}>
                        <Input placeholder="Last name" />
                      </Form.Item>
                    </Space.Compact>

                    <Space.Compact style={{ width: '100%' }}>
                      <Form.Item name="email" style={{ flex: 1, marginRight: 10 }} rules={[
                        { required: true, message: 'Please enter your email!' },
                        { type: 'email', message: 'Invalid email format!' },
                        { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: 'Please enter a valid email address!' },
                      ]}>
                        <Input autoComplete="off" placeholder="Email" />
                      </Form.Item>
                      <Form.Item name="role" style={{ flex: 1 }} rules={[{ required: true, message: 'please select your role' }]}>
                        <Select placeholder="Role">
                          <Option value="admin">Admin</Option>
                          <Option value="Corporate-Admin">Corporate-Admin</Option>
                          <Option value="CSR">CSR</Option>
                          <Option value="CSR-R">CSR-R</Option>
                        </Select>
                      </Form.Item>
                    </Space.Compact>

                    <Space.Compact style={{ width: '100%' }}>
                      <Form.Item name="password" style={{ flex: 1, marginRight: 10 }} rules={[
                        { required: userDataSet && Object.keys(userDataSet).length ? false : true, message: 'Enter password' },
                        { pattern: passwordRegex, message: 'Password must be at least 8 characters, with uppercase, lowercase, number, and special character.' },
                      ]}>
                        <Input.Password placeholder="Password" iconRender={(v) => (v ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                      </Form.Item>
                      <Form.Item name="confirmPassword" style={{ flex: 1 }} rules={[
                        { required: userDataSet && Object.keys(userDataSet).length ? false : true, message: 'Re Enter password' },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password') === value) return Promise.resolve();
                            return Promise.reject(new Error('Passwords do not match!'));
                          },
                        }),
                      ]}>
                        <Input.Password placeholder="Confirm password" iconRender={(v) => (v ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                      </Form.Item>
                    </Space.Compact>

                    <Form.Item>
                      <Button type="primary" className="add-generic-btn" style={{ backgroundColor: '#008385', borderColor: '#008385', color: '#fff', marginRight: 10 }} onClick={handleClearform}>Cancel</Button>
                      <Button type="primary" htmlType="submit" loading={isSubmitting} disabled={isSubmitting} style={{ backgroundColor: isSubmitting ? '#80bebe' : '#008385', borderColor: isSubmitting ? '#80bebe' : '#008385', color: '#fff' }}>
                        {isSubmitting ? 'Saving...' : 'Save'}
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form>
            )}
          </Card>
        )}
      </div>
    </App>
  )
}

export default ManageUser
